import { render, staticRenderFns } from "./StorageDetails.vue?vue&type=template&id=5d5b2f0e&"
import script from "./StorageDetails.vue?vue&type=script&lang=js&"
export * from "./StorageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports